/** Casdoor org from Vite env (e.g. `jinggui`, `coca-org`). */
export function getCasdoorOrgName(): string {
  return import.meta.env.VITE_CASDOOR_ORG_NAME?.trim() ?? '';
}

/** True when deploy targets a jinggui tenant (org name contains "jinggui"). */
export function isJingguiOrg(): boolean {
  return getCasdoorOrgName().toLowerCase().includes('jinggui');
}
